module.exports = __webpack_public_path__ + "img/break.4b7a42bd.svg";